<mat-sidenav-container class="app-container">
  <mat-sidenav mode="side" opened class="integration-sidenav">
    <div class="sidenav-wrapper">
      <mat-nav-list>
        <a
          mat-list-item
          routerLink="/integration/manual"
          routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }"
          class="tab-link"
        >
          <mat-icon matListItemIcon>description</mat-icon>
          <span matListItemTitle>User Manual</span>
        </a>

        <a
          mat-list-item
          routerLink="/integration/layers"
          routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: false }"
          class="tab-link"
        >
          <mat-icon matListItemIcon>call_merge</mat-icon>
          <span matListItemTitle>Integration</span>
        </a>

        <a
          mat-list-item
          routerLink="/integration/logs"
          routerLinkActive="active-item"
          [routerLinkActiveOptions]="{ exact: true }"
          class="tab-link"
        >
          <mat-icon matListItemIcon>integration_instructions</mat-icon>
          <span matListItemTitle>Logs</span>
        </a>
      </mat-nav-list>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
